import { HugeiconsIcon } from "@hugeicons/react"
import { Cancel01Icon, File01Icon } from "@hugeicons/core-free-icons"
import type { IssueAttachment } from "../types/assistant.types"

interface AttachmentPillProps {
  attachment: IssueAttachment
  onRemove: () => void
}

export function AttachmentPill({ attachment, onRemove }: AttachmentPillProps) {
  const isImage = attachment.content_type.startsWith("image/")

  return (
    <div className="flex items-center gap-2 rounded-lg border bg-background px-2 py-1 pr-1 ring-1 ring-border">
      {isImage ? (
        <img
          src={attachment.url}
          alt={attachment.original_name}
          className="h-6 w-6 shrink-0 rounded object-cover"
        />
      ) : (
        <div className="flex h-6 w-6 shrink-0 items-center justify-center rounded bg-muted">
          <HugeiconsIcon
            icon={File01Icon}
            size={12}
            className="text-muted-foreground"
          />
        </div>
      )}
      <span
        className="max-w-[140px] truncate text-xs"
        title={attachment.original_name}
      >
        {attachment.original_name}
      </span>
      <button
        type="button"
        onClick={onRemove}
        className="ml-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded text-muted-foreground hover:bg-muted hover:text-foreground cursor-pointer"
        title="Remove"
      >
        <HugeiconsIcon icon={Cancel01Icon} size={12} />
      </button>
    </div>
  )
}
